import { render, staticRenderFns } from "./Loginhome.vue?vue&type=template&id=96759e1a&scoped=true"
import script from "./Loginhome.vue?vue&type=script&lang=js"
export * from "./Loginhome.vue?vue&type=script&lang=js"
import style0 from "./Loginhome.vue?vue&type=style&index=0&id=96759e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96759e1a",
  null
  
)

export default component.exports